import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { d: "M12 20L18.9282 8H5.0718L12 20Z" }), 'ArrowIcon');
